import { render, staticRenderFns } from "./TrendingProductTile.vue?vue&type=template&id=09549c54"
import script from "./TrendingProductTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingProductTile.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopProductTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/CreatorShopProductTile.vue').default,TrackProductImpression: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Track/TrackProductImpression.vue').default})
